import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  DatePicker,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  InputNumber,
  Button,
  Divider,
} from "antd";
import { CloseCircleFilled, PlusOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { apiConfig, labelConfig, staticConfig } from "../customer.config";
// import { apiConfig, labelConfig, staticConfig } from "../customer.config";

import styles from "../../../assets/styles/styles";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const EditCustomer = (props) => {
  //DECLARED VARIABLES
  const { userData, onSelectItemAction, rightBtn, rightAction, getGlListAction } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  // const [form] = Form.useForm();
  // const isActive = Form.useWatch("active", useForm);
  const idType = Form.useWatch("idTypeId", useForm);
  // const openCasa = Form.useWatch("openCasa", useForm);
  const legalOption = Form.useWatch("legalFormId", useForm);

  const dispatch = useDispatch();

  const [officeData, setOfficeData] = useState([]);
  const [legalFormData, setLegalFormData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [titleData, setTitleData] = useState([]);
  const [savingsProduct, setSavingsProduct] = useState([]);
  const [activationDate, setActivationDate] = useState([]);
  const [clientClassificationData, setClientClassificationData] = useState([]);
  const [clientNonPersonConstitutionOptions, setClientNonPersonConstitutionOptions] = useState([]);
  const [clientNonPersonMainBusinessLineOptions, setClientNonPersonMainBusinessLineOptions] =
    useState([]);
  const [staffData, setStaffData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [identifactionTypeData, setIdentificattionTypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    //ACTIVATE SAVE RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.RIGHT_SAVE_BTN,
    // });
    console.log(state);
    setIsLoading(false);
    getTemplate();
    // getDetailById();
  }, []);

  function getTemplate() {
    // setIsLoading(true);

    const url = `${apiConfig.Clients}/${state.id}?staffInSelectedOfficeOnly=true&template=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // console.log(objDetail);

        useForm.setFieldsValue({
          tier: objDetail.tier,
          legalFormId: objDetail.legalForm.id,
          officeId: objDetail.officeId,
          clientTypeId: objDetail.clientType.id,
          fullname: objDetail.displayName,
          firstname: objDetail.firstname,
          lastname: objDetail.lastname,
          emailAddress: objDetail.emailAddress,
          mobileNo: objDetail.mobileNo,
          constitutionId: objDetail.clientNonPersonDetails.constitution.id,
          mainBusinessLineId: objDetail.clientNonPersonDetails.mainBusinessLine.id,
          accountNo: objDetail.accountNo,
          active: objDetail.active,
          isStaff: objDetail?.isStaff,
          riskRating: objDetail?.riskRating,
          pepStatus: objDetail.pepStatus,
          dateOfBirth: objDetail.dateOfBirth
            ? dayjs(BOM.FormatArrayDate(objDetail.dateOfBirth))
            : objDetail.dateOfBirth,
          activationDate: objDetail.timeline.activatedOnDate
            ? dayjs(BOM.FormatArrayDate(objDetail.timeline.activatedOnDate))
            : objDetail.timeline.activatedOnDate,
          submittedOnDate: objDetail.timeline.submittedOnDate
            ? dayjs(BOM.FormatArrayDate(objDetail.timeline.submittedOnDate))
            : objDetail.timeline.submittedOnDate,
          genderId: objDetail?.gender?.id,
          externalId: objDetail?.externalId,
          staffId: objDetail?.staffId,
          clientClassificationId: objDetail?.clientClassification?.id,
          idTypeId: objDetail?.idType?.id,
          idNumber: objDetail?.idNumber,
          idIssuingDate: objDetail?.idIssuingDate
            ? dayjs(BOM.FormatArrayDate(objDetail.idIssuingDate))
            : objDetail.idIssuingDate,
          passExpDate: objDetail?.passExpDate
            ? dayjs(BOM.FormatArrayDate(objDetail.passExpDate))
            : objDetail.passExpDate,
        });

        let tempOfficeData = [];
        let tempLegalFormData = [];
        let tempCustomerType = [];
        let tempTitle = [];
        let tempCountries = [];
        let tempCountryId = [];
        let tempAddressTypeId = [];
        let tempStateProvinceId = [];
        let tempGender = [];
        let tempIdentification = [];
        let tempClientClassification = [];
        let tempClientNonPersonConstitutionOptions = [];
        let tempClientNonPersonMainBusinessLineOptions = [];
        let tempStaffData = [];
        let tempSavingsProduct = [];

        objDetail?.officeOptions?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.clientLegalFormOptions?.forEach((element) => {
          tempLegalFormData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.clientTypeOptions?.forEach((element) => {
          tempCustomerType.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.genderOptions?.forEach((element) => {
          tempGender.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.countryOptions?.forEach((element) => {
          tempCountries.push({
            value: element.description,
            label: element.name,
          });
        });

        objDetail?.clientClassificationOptions?.forEach((element) => {
          tempClientClassification.push({
            value: element.id,
            label: element.name,
          });
        });
        objDetail?.clientNonPersonConstitutionOptions?.forEach((element) => {
          tempClientNonPersonConstitutionOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.clientNonPersonMainBusinessLineOptions?.forEach((element) => {
          tempClientNonPersonMainBusinessLineOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.staffOptions?.forEach((element) => {
          tempStaffData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objDetail?.savingProductOptions
          ?.filter((item) => item.allowOverdraft === false)
          .forEach((element) => {
            tempSavingsProduct.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        // objDetail?.savingProductOptions?.forEach((element) => {
        //   tempSavingsProduct.push({
        //     value: element.id,
        //     label: element.name,
        //   });
        // });

        objDetail?.idTypes?.forEach((element) => {
          tempIdentification.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);
        setLegalFormData(tempLegalFormData);
        setCustomerTypeData(tempCustomerType);
        setTitleData(tempTitle);
        setSavingsProduct(tempSavingsProduct);
        setActivationDate(objDetail?.activationDate);
        setClientClassificationData(tempClientClassification);
        setClientNonPersonConstitutionOptions(tempClientNonPersonConstitutionOptions);
        setClientNonPersonMainBusinessLineOptions(tempClientNonPersonMainBusinessLineOptions);
        setStaffData(tempStaffData);
        setCountryData(tempCountries);
        setCountryIdData(tempCountryId);
        setAddressTypeIdData(tempAddressTypeId);
        setStateProvinceIdData(tempStateProvinceId);
        setGenderData(tempGender);
        setIdentificattionTypeData(tempIdentification);
        setIsLoading(false);
      }
    });
  }

  function onCancel() {
    navigate("/cst0100", { replace: false });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Clients}/${state.id}`;

    formValues.dateOfBirth = formValues.dateOfBirth
      ? BOM.DateTime(formValues.dateOfBirth, "only-date")
      : formValues.dateOfBirth;
    formValues.activationDate = formValues.activationDate
      ? BOM.DateTime(formValues.activationDate, "only-date")
      : formValues.activationDate;
    formValues.submittedOnDate = formValues.submittedOnDate
      ? BOM.DateTime(formValues.submittedOnDate, "only-date")
      : formValues.submittedOnDate;
    formValues.idIssuingDate = formValues.idIssuingDate
      ? BOM.DateTime(formValues.idIssuingDate, "only-date")
      : formValues.idIssuingDate;
    formValues.passExpDate = formValues.passExpDate
      ? BOM.DateTime(formValues.passExpDate, "only-date")
      : formValues.passExpDate;

    formValues.clientNonPersonDetails = {
      constitutionId: formValues.constitutionId,
      dateFormat: "dd MMMM yyyy",
      incorpNumber: formValues.incorpNumber,
      incorpValidityTillDate: formValues.incorpValidityTillDate
        ? BOM.DateTime(formValues.incorpValidityTillDate, "only-date")
        : formValues.incorpValidityTillDate,
      locale: "en",
      mainBusinessLineId: formValues.mainBusinessLineId,
      remarks: formValues.remarks,
    };

    delete formValues.officeId;
    delete formValues.openCasa;
    delete formValues.constitutionId;
    delete formValues.incorpNumber;
    delete formValues.incorpValidityTillDate;
    delete formValues.mainBusinessLineId;
    delete formValues.remarks;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        // This callback ONLY runs when there's NO commandId
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          // Show success message - we know there's no commandId here
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.editCustomerMsg);
          navigate("/detail-customer", {
            state: { ...state },
          });
        }
        setIsLoading(false);
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-customer", {
            state: { ...state },
          });
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.editCustomer}
        pageItems={staticConfig.editBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: false,
              isStaff: false,
              openCasa: false,
            }}
            form={useForm}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.customerSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.generalInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.customerType} name="clientTypeId">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(`${labelConfig.customerType}`, "select")}
                    options={customerTypeData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.legalForm}
                  name="legalFormId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.legalForm),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(`${labelConfig.legalForm}`, "select")}
                    options={legalFormData}
                    showSearch
                    disabled
                    className="of-bold-disable-input read-only-select"
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.branch}
                  name="officeId"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.branch),
                    },
                  ]}
                >
                  <Select
                    className="of-bold-disable-input read-only-select"
                    placeholder={BOM.handlePlaceholderMsg(`${labelConfig.branch}`, "select")}
                    options={officeData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              {legalOption === 2 && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.name}
                    name="fullname"
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.name),
                      },
                    ]}
                  >
                    <Input
                      disabled
                      className="of-bold-disable-input"
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                    />
                  </Form.Item>
                </Col>
              )}
              {!(legalOption === 2) && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.firstName}
                      name="firstname"
                      rules={BOM.fieldRules("firstName", true)}
                    >
                      <Input
                        disabled
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.firstName)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.middleName}
                      name="middlename"
                      rules={BOM.fieldRules("middleName", false)}
                    >
                      <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.middleName)} />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.lastName}
                      name="lastname"
                      rules={BOM.fieldRules("lastName", true)}
                    >
                      <Input
                        // disabled
                        className="of-bold-disable-input"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.lastName)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.dateOfBirth} name="dateOfBirth">
                      <DatePicker
                        disabled
                        className="of-bold-disable-input disable-date"
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.dateOfBirth, "select")}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.gender} name="genderId">
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.gender, "select")}
                        options={genderData}
                        disabled
                        className="of-bold-disable-input read-only-select"
                      />
                    </Form.Item>
                  </Col>
                </>
              )}

              {/* <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.status} name="active">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${labelConfig.status}`,
                      "select"
                    )}
                    options={staticConfig.statusData}
                    showSearch
                  />
                </Form.Item>
              </Col> */}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={"Customer ID"} name="accountNo">
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    placeholder={BOM.handlePlaceholderMsg("Customer ID")}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    legalOption === 2
                      ? labelConfig.businessRegistrationNumber
                      : labelConfig.externalID
                  }
                  name="externalId"
                  rules={[
                    {
                      required: legalOption === 2 ? true : false,
                      validator(_, value) {
                        if (legalOption === 2 && !value) {
                          return Promise.reject(
                            new Error("Business Registration Number is required"),
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      legalOption === 2
                        ? labelConfig.businessRegistrationNumber
                        : labelConfig.externalID,
                    )}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
              {/* {isActive && ( */}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.activationDate}
                  name="activationDate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.activationDate),
                    },
                  ]}
                >
                  <DatePicker
                    disabled
                    className="of-bold-disable-input disable-date"
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.activationDate, "select")}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={"Tier"} name="tier">
                  <Input
                    disabled
                    className="of-bold-disable-input"
                    placeholder={BOM.handlePlaceholderMsg("Tier")}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.contactInfo}
                </Title>
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.email}
                  name="emailAddress"
                  rules={[
                    {
                      required: true,
                      type: "email",
                    },
                  ]}
                >
                  <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.email)} />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.mobileNumber}
                  name="mobileNo"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.mobileNumber),
                  //   },
                  // ]}
                  rules={[
                    () => ({
                      validator(_, value) {
                        console.log(value);
                        if (!value) {
                          return Promise.reject(new Error("Mobile number is required"));
                        }
                        if (value?.length !== 11) {
                          return Promise.reject(
                            new Error("Mobile number must be exactly 11 digits"),
                          );
                        }
                        if (!/^[0-9]{11}$/.test(value)) {
                          return Promise.reject(
                            new Error("Mobile number must contain only numbers"),
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.mobileNumber)}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
              {legalOption === 2 && (
                <>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.incorporationDate} name="dateOfBirth">
                      <DatePicker
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.incorporationDate,
                          "select",
                        )}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      label={labelConfig.incorporationValidUntil}
                      name="incorpValidityTillDate"
                    >
                      <DatePicker
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.incorporationValidUntil,
                          "select",
                        )}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.sourceOfWealth} name="proofSow">
                      <Input placeholder={BOM.handlePlaceholderMsg(labelConfig.sourceOfWealth)} />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld(labelConfig.taxIDNumber),
                        },
                      ]}
                      label={labelConfig.taxIDNumber}
                      name="incorpNumber"
                    >
                      <Input
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.taxIDNumber)}
                        style={styles.ofInputFieldNumber}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.constitution} name="constitutionId">
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.constitution, "select")}
                        options={clientNonPersonConstitutionOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.mainBusinessLine} name="mainBusinessLineId">
                      <Select
                        placeholder={BOM.handlePlaceholderMsg(
                          labelConfig.mainBusinessLine,
                          "select",
                        )}
                        options={clientNonPersonMainBusinessLineOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ padding: "0px 8px" }}>
                    <Form.Item label={labelConfig.remarks} name="remarks">
                      <TextArea
                        showCount
                        maxLength={100}
                        placeholder={BOM.handlePlaceholderMsg(labelConfig.remarks)}
                        style={{
                          height: 120,
                          resize: "none",
                        }}
                      ></TextArea>
                    </Form.Item>
                  </Col>
                </>
              )}

              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {labelConfig.additionalInfo}
                </Title>
              </Divider>
              {!(legalOption === 2) && (
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.isStaff} name="isStaff">
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.isStaff, "select")}
                      options={staticConfig.yesOrNoData}
                      showSearch
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.relationshipManager} name="staffId">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.relationshipManager,
                      "select",
                    )}
                    options={staffData}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.pepStatus} name="pepStatus">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.pepStatus, "select")}
                    options={staticConfig.pepStatusData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.riskRating} name="riskRating">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.riskRating, "select")}
                    options={staticConfig.riskRatingData}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.customerClassification} name="clientClassificationId">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.customerClassification,
                      "select",
                    )}
                    options={clientClassificationData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.submittedOn} name="submittedOnDate">
                  <DatePicker
                    disabled
                    className="of-bold-disable-input disable-date"
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.submittedDate, "select")}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_CLIENT") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditCustomer);
